var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3098 11.0401L9.82023 21.5297C9.46344 21.8865 8.96393 22.0506 8.47156 21.9864L3.36234 21.3227C2.63449 21.23 2.06362 20.6591 1.97086 19.9312L1.30723 14.822C1.24301 14.3225 1.41427 13.823 1.76392 13.4734L13.752 1.47096C14.38 0.843013 15.4075 0.843013 16.0355 1.47096L19.3394 4.77483C19.9673 5.40278 19.9673 6.43033 19.3394 7.05828L8.66423 17.7334L5.90268 17.3766L5.54589 14.6151L14.7154 5.45273",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/Attach.bf2d0d8ae4c91a76a4eb90c21e0d3eb6.svg";
export { ForwardRef as ReactComponent };